import { render, staticRenderFns } from "./openVillage.vue?vue&type=template&id=f0e2415a&scoped=true&"
import script from "./openVillage.vue?vue&type=script&lang=js&"
export * from "./openVillage.vue?vue&type=script&lang=js&"
import style0 from "./openVillage.vue?vue&type=style&index=0&id=f0e2415a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e2415a",
  null
  
)

export default component.exports